import * as React from 'react';

export const CheckIcon = ({
  height = '48px',
  width = '48px',
  secondaryColor,
  ...props
}: React.SVGProps<SVGSVGElement> & { secondaryColor?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 48 48"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M46.2467 12L44.1279 14.1188L20.1279 38.1188L17.9998 40.2469L15.8811 38.1282L3.88105 26.1282L1.75293 24L5.9998 19.7532L8.11855 21.8719L17.9998 31.7532L39.8811 9.8813L41.9998 7.75317L46.2467 12Z"
      fill="#424242"
    />
  </svg>
);
